import * as t from "io-ts";
import nullable from "./nullable";
import { cargoQualityT, cargoTypeT, trailerQualityT } from "./types";
export const teamInputT = t.strict({
    name: t.string,
    description: nullable(t.string),
});
export const teamResourcesPropT = t.strict({
    cargoTypes: t.array(cargoTypeT),
    cargoQualities: t.array(cargoQualityT),
    cargoRequirements: t.array(trailerQualityT),
});
export const teamDriverT = t.strict({
    teamId: t.string,
    driverId: t.string,
});
export const teamVehicleT = t.strict({
    teamId: t.string,
    trailerId: t.string,
});
export const teamDriversT = t.array(teamDriverT);
export const teamVehiclesT = t.array(teamVehicleT);
export const idT = t.strict({ id: t.string });
export const updateTeamCargoTypesT = t.strict({
    cargoTypes: t.array(cargoTypeT),
});
export const updateTeamCargoQualitiesT = t.strict({
    cargoQualities: t.array(cargoQualityT),
});
export const updateTeamCargoRequirementsT = t.strict({
    cargoRequirements: t.array(trailerQualityT),
});
export const teamT = t.intersection([idT, teamInputT, teamResourcesPropT]);
export const teamsT = t.array(teamT);
//# sourceMappingURL=team.js.map